import React, { createContext } from 'react';
import useNotificationsReducer from '../../hooks/use-notifications/useNotificationsReducer';
const voidFn = () => {};
export const NotificationsContext = /*#__PURE__*/createContext({
  notifications: [],
  add: voidFn,
  addSuccess: voidFn,
  addError: voidFn,
  addWarning: voidFn,
  remove: voidFn,
  clear: voidFn
});
export const NotificationsProvider = _ref => {
  let {
    children
  } = _ref;
  const contextValue = useNotificationsReducer();
  return /*#__PURE__*/React.createElement(NotificationsContext.Provider, {
    value: contextValue
  }, children);
};
//# sourceMappingURL=NotificationsContext.js.map